import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { Text } from 'react-native';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Button, Stack, Icon, HeaderText,
} from '../../../../../ui';
import { useAssignTest } from '../../../../../../hooks';
import TimeToComplete from './TimeToComplete';

import { InsightCardProps } from '../types';

export const BASE_ID = 'marketing-tips-marquee-card';
const AdsRanMarqueeCard: React.FC<InsightCardProps> = ({
  id,
  cta,
  clickThroughData,
  analyticsData,
  onClick,
  onAction,
  firstViewTracking,
  metadata = {},
  image,
  timeToComplete,
}) => {
  const instanceId = `${BASE_ID}-${id}`;
  const [hasTracked, setHasTracked] = useState(false);
  const {
    metro, reach, assignment, flag,
  } = metadata;
  const lastLine = metro ? `in ${metro}` : 'last month';
  const assignTest = useAssignTest(flag, 0);

  if (assignment) {
    const percent = assignment === 'test' ? 1 : 0;
    assignTest(percent);
  }

  const visibilityChangeHandler = isVisible => {
    if (hasTracked) {
      return;
    }

    if (isVisible && firstViewTracking) {
      setHasTracked(true);
      firstViewTracking?.();
    }
  };

  return (
    <VisibilitySensor onChange={visibilityChangeHandler}>
      <Box
        padding={4}
        testID={instanceId}
      >
        <Inline
          alignItems="center"
          showBoxShadow
          color={colors.whiteWash}
          minHeight={260}
          justifyContent="space-evenly"
        >
          <Stack
            maxWidth={206}
            paddingX={16}
            justifyContent="center"
            space={20}
          >
            <Inline paddingBottom={16}>
              <TimeToComplete
                testId={`${instanceId}-time-to-complete`}
                time={timeToComplete}
              />
            </Inline>
            <Text style={{ textAlign: 'center' }}>
              <HeaderText
                level={3}
                color={colors.blackInBlack}
              >
                {'StyleSeat social media ads reached '}
              </HeaderText>
              <HeaderText level={3} color={colors.slate}>
                {'over '}
                {reach}
              </HeaderText>
              <HeaderText
                level={3}
                color={colors.blackInBlack}
              >
                {' people for you '}
                {lastLine}
              </HeaderText>
            </Text>
            <Inline>
              <Button
                size="small"
                onClick={() => onClick(clickThroughData, analyticsData, onAction)}
                testID={`${instanceId}-cta`}
              >
                {cta}
              </Button>
            </Inline>
          </Stack>
          <Box
            color={colors.lightChill}
            minWidth={129}
            minHeight={260}
            alignItems="center"
            justifyContent="center"
          >
            <Icon uri={image} width={98} height={99} />
          </Box>
        </Inline>
      </Box>
    </VisibilitySensor>
  );
};

export default AdsRanMarqueeCard;
